import { HeartPulse, ScanSearch, Dumbbell, Briefcase } from "lucide-react";

export const SERVICE_GROUPS = [
  {
    id: "pain-spine-care",
    title: "Pain and spine care",
    icon: HeartPulse,
    items: [
      ["Back pain management", "Assessment and a conservative, personalised plan for recent or long-standing back pain."],
      ["Neck pain management", "Care for neck pain and stiffness, including posture and screen-time habits."],
      ["Slip disc / herniated disc management", "Non-surgical management of disc-related pain, guided by your symptoms and examination."],
      ["Sciatica management", "Assessment and conservative care for pain that travels from the back into the leg."],
      ["Pain management", "Evidence-based approaches to help ease pain and keep you active."],
      ["Muscle and joint pain management", "Care for musculoskeletal aches, strains and stiffness."],
      ["Sports-related spine injuries", "Assessment and graded return-to-activity guidance after a sports strain or injury."],
    ],
  },
  {
    id: "assessment-prevention",
    title: "Assessment and prevention",
    icon: ScanSearch,
    items: [
      ["Spine screening", "A clinical check of your spine, posture and movement to identify risk factors early."],
      ["Posture assessment and correction", "Identifying posture habits that load your spine, and how to correct them."],
      ["Preventive spine care", "Practical guidance to help reduce the risk of recurring problems."],
    ],
  },
  {
    id: "rehabilitation",
    title: "Rehabilitation",
    icon: Dumbbell,
    items: [
      ["Physiotherapy", "Guided exercises and therapy to improve movement, strength and flexibility."],
      ["Rehabilitation", "Structured, step-by-step programmes to rebuild function after pain or injury."],
      ["Exercise and movement guidance", "Exercises suited to your condition that you can continue at home."],
    ],
  },
  {
    id: "workplace-health",
    title: "Workplace health",
    icon: Briefcase,
    items: [
      ["Ergonomic assessment", "A review of how you sit, stand and work, with practical adjustments."],
      ["Workplace ergonomics", "Guidance on desk, computer and workplace set-ups to reduce strain."],
      ["Occupational health consultation", "Consultation on work-related health concerns with an occupational health physician."],
    ],
  },
];
